import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69b784386b5d6f0014e1023f/spinefinance/src/app/yield-curve-simulator/components/EditPageClient.tsx");
